module.exports = __webpack_public_path__ + "img/big.6cb53051.webp";